import { apiService } from './api';

export type AttendanceStatus = 'PRESENT' | 'ABSENT' | 'LEAVE' | 'HALF_DAY';

export interface Attendance {
  id: string;
  employeeId: string;
  employeeName?: string;
  date: string;            // yyyy-MM-dd
  clockIn?: string;        // ISO instant
  clockOut?: string;
  workedMinutes?: number;
  status: AttendanceStatus;
  notes?: string;
  organizationCode: string;
  restaurantId?: string;
}

export const attendanceService = {
  async list(org: string, restaurantId?: string, date?: string, employeeId?: string): Promise<Attendance[]> {
    const response = await apiService.get<Attendance[]>('/attendance', {
      org,
      ...(restaurantId && { restaurantId }),
      ...(date && { date }),
      ...(employeeId && { employeeId }),
    });
    return response.data;
  },

  async clockIn(org: string, restaurantId: string | undefined, employeeId: string, employeeName?: string): Promise<Attendance> {
    const response = await apiService.post<Attendance>('/attendance/clock-in', { org, restaurantId, employeeId, employeeName });
    return response.data;
  },

  async clockOut(id: string): Promise<Attendance> {
    const response = await apiService.post<Attendance>(`/attendance/${id}/clock-out`, {});
    return response.data;
  },

  async mark(data: Partial<Attendance> & { organizationCode: string; employeeId: string }): Promise<Attendance> {
    const response = await apiService.post<Attendance>('/attendance', data);
    return response.data;
  },

  async update(id: string, data: Partial<Attendance>): Promise<Attendance> {
    const response = await apiService.put<Attendance>(`/attendance/${id}`, data);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/attendance/${id}`);
  },
};
